import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <p>© {new Date().getFullYear()} KATAR KENTSEL YAPI VE İNŞAAT TİC. LTD. ŞTİ. Tüm hakları saklıdır.</p>
  </footer>
);

export default Footer; 